import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Btn from "./Btn";
import ThemeToggle from "./ThemeToggle";

export const NAV_ITEMS = [
  { label: "Beranda", to: "/" },
  { label: "Tentang Kami", to: "/tentang" },
  { label: "Fitur", to: "/fitur" },
  { label: "Paket", to: "/paket" },
  { label: "Testimoni", to: "/testimoni" },
  { label: "FAQ", to: "/faq" },
  { label: "Syarat & Ketentuan", to: "/terms" },
  { label: "Kebijakan Refund", to: "/refund" },
  { label: "Kontak", to: "/contact" },
];

export default function LandingNav() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => { setOpen(false); }, [pathname]);
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  const tid = (to) => `nav-${to === "/" ? "beranda" : to.slice(1)}`;

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-su-surface/85 border-b-2 border-su-border" data-testid="landing-nav">
      <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <img src="/brand/skorup_icon.png" alt="SkorUp.io" className="w-9 h-9 rounded-xl object-cover shadow-[0_3px_0_var(--su-primary-shadow)]" />
          <span className="font-heading font-black text-lg">SkorUp<span className="text-su-primary">.io</span></span>
        </Link>

        {/* desktop nav */}
        <nav className="hidden lg:flex items-center gap-0.5">
          {NAV_ITEMS.map((it) => {
            const active = pathname === it.to;
            return (
              <Link key={it.to} to={it.to} data-testid={tid(it.to)}
                className={`px-3 py-2 rounded-xl font-heading font-extrabold text-[13px] whitespace-nowrap transition-colors ${active ? "bg-su-primary/12 text-su-primary" : "text-su-muted hover:text-su-text hover:bg-su-border/40"}`}>
                {it.label}
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-2 shrink-0">
          <ThemeToggle />
          <Link to="/auth" className="hidden sm:block"><Btn data-testid="landing-signup" size="sm">Daftar Gratis</Btn></Link>
          <Link to="/auth" className="hidden sm:block lg:hidden"><Btn data-testid="landing-login" variant="ghost" size="sm">Masuk</Btn></Link>
          <Link to="/auth" className="hidden lg:block"><Btn data-testid="landing-login-lg" variant="ghost" size="sm">Masuk</Btn></Link>
          {/* hamburger (mobile/tablet) */}
          <button data-testid="nav-hamburger" aria-label="Menu" onClick={() => setOpen((v) => !v)}
            className="lg:hidden w-10 h-10 grid place-items-center rounded-xl border-2 border-su-border text-su-text active:scale-95 transition-transform">
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {/* mobile drawer */}
      {open && (
        <div className="lg:hidden fixed inset-0 top-16 z-40" data-testid="nav-mobile-drawer">
          <div className="absolute inset-0 bg-black/50" onClick={() => setOpen(false)} />
          <nav className="relative bg-su-surface border-b-2 border-su-border max-h-[calc(100vh-4rem)] overflow-y-auto p-3 shadow-2xl">
            {NAV_ITEMS.map((it) => {
              const active = pathname === it.to;
              return (
                <Link key={it.to} to={it.to} data-testid={`m-${tid(it.to)}`} onClick={() => setOpen(false)}
                  className={`block px-4 py-3 rounded-xl font-heading font-extrabold text-base mb-1 ${active ? "bg-su-primary/12 text-su-primary" : "text-su-text hover:bg-su-border/40"}`}>
                  {it.label}
                </Link>
              );
            })}
            <div className="grid grid-cols-2 gap-2 mt-3 pt-3 border-t-2 border-su-border">
              <Link to="/auth" onClick={() => setOpen(false)}><Btn data-testid="m-login" variant="ghost" className="w-full">Masuk</Btn></Link>
              <Link to="/auth" onClick={() => setOpen(false)}><Btn data-testid="m-signup" className="w-full">Daftar Gratis</Btn></Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
